import { z } from 'zod';
import { ObjectIdSchema } from '../../shared/object-id.schema';
/**
 * POST /api/v2/process/:id/draft/steps/:stepId/successors — connect
 *
 * The target may be a draft step or a draft assignment — both share the
 * `stableStepId` space, so the backend resolves `targetStepId` across both
 * collections. The response is the shared `DraftNodeEnvelopeSchema`: the
 * recomputed source plus the updated target, each self-describing via
 * `nodeKind`.
 */ export const ConnectDraftStepsRequestSchema = z.object({
    targetStepId: ObjectIdSchema,
    ruleId: ObjectIdSchema.optional()
});

//# sourceMappingURL=connect-draft-steps.schema.js.map